import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
    path: 'id',
  })

  return {
    requestPolicy: 'network-only',
    variables: {
      patient_id,
    },
  }
}
